module.exports = __webpack_public_path__ + "static/img/e4.d976963.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/e4.png
// module id = l5hM
// module chunks = 0